/**
 * Team section
 */

$('.s-team .read-more-label').on('click', function () {
    const $this = $(this);
    const readLess = $this.data('read-less');
    const readMore = $this.data('read-more');

    $this.siblings('.s-team__team-members--member-biography-extended').slideToggle();

    if ($this.children('.read-more-label__text').text() === readMore) {
        $this.children('.read-more-label__text').text(function () {
            return readLess;
        });
    } else if ($this.children('.read-more-label__text').text() === readLess) {
        $this.children('.read-more-label__text').text(function () {
            return readMore;
        });
    }
});


// WEBPACK FOOTER //
// ./scripts/routes/sections/team.js